// #2704 -- share ONE in-flight request between callers that ask for the same
// thing at the same moment. This is not a cache: the entry is dropped the
// instant the request settles, so the next call (the next poll) always goes to
// the network. Scope is per owner: AnnouncerProvider holds one owner object in
// a useRef({}) and hands it to both consumers, so only callers under the same
// provider instance share a request (a fresh render tree, e.g. a test's, gets
// a new owner and never joins another's). The key (`class:${showId}`) does not
// include the api, so the owner is the only scope boundary.
const inflightByOwner = new WeakMap();

export function coalesceInflight(owner, key, run) {
  let byKey = inflightByOwner.get(owner);
  if (!byKey) {
    byKey = new Map();
    inflightByOwner.set(owner, byKey);
  }
  const existing = byKey.get(key);
  if (existing) return existing;
  const promise = Promise.resolve()
    .then(run)
    .finally(() => {
      if (byKey.get(key) === promise) byKey.delete(key);
    });
  byKey.set(key, promise);
  return promise;
}
